module.exports = __webpack_public_path__ + "img/dp_logo_w.804fed78.png";